module.exports = __webpack_public_path__ + "2eb913c16b25e32008e27d315a8e9fba.svg";